import styled from 'styled-components';
export const TableBody = styled.tbody`
  padding: 0.5rem;
`;